<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<pre *ngFor="let account of accounts">{{ account }}</pre>
